import { Outlet, RouteObject } from 'react-router';

import { AppContainerWithMenu } from '@sternum/web/features/appContainerWithMenu';
import { ProtectedRoute } from '@sternum/web/routes/ProtectedRoute';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { attacksPaths } from './paths';

const { AttacksView } = lazyImport(() => import('../views/attacks'), 'AttacksView');
const { AttackDetailsView } = lazyImport(() => import('../views/attackDetails'), 'AttackDetailsView');

function Layout() {
  return (
    <ProtectedRoute>
      <AppContainerWithMenu>
        <Outlet />
      </AppContainerWithMenu>
    </ProtectedRoute>
  );
}

export const attacksRoutes: RouteObject[] = [
  {
    path: attacksPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <AttacksView /> },
      { path: attacksPaths.attackDetails.relative, element: <AttackDetailsView /> },
    ],
  },
];
